import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import update from 'immutability-helper';
import { connect } from 'react-redux';
import QuestionsContainer from '../../common/QuestionsContainer';
import ClaimPastRole from './ClaimPastRole';
import chemistImg from '../../../../assets/images/referral-person.jpg';
import { putRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import './Beginning.scss';
import Tooltip from '../../common/Tooltip';
import { processedProfileSuggestions } from '../onboardingUtils';
var Beginning = /*#__PURE__*/function (_Component) {
  function Beginning(props) {
    var _this;
    _classCallCheck(this, Beginning);
    _this = _callSuper(this, Beginning, [props]);
    var bio = props.bio,
      location = props.location,
      education = props.education,
      pastRoles = props.pastRoles,
      functionalAreas = props.functionalAreas,
      therapeuticAreas = props.therapeuticAreas,
      industries = props.industries,
      productTechnologies = props.productTechnologies,
      stagesOfDevelopments = props.stagesOfDevelopments;
    _this.state = {
      page: 0,
      wasQuestionsUpdated: false,
      experiences: {},
      location: location,
      bio: bio,
      education: education,
      pastRoles: pastRoles,
      functionalAreas: functionalAreas,
      industries: industries,
      productTechnologies: productTechnologies,
      therapeuticAreas: therapeuticAreas,
      stagesOfDevelopments: stagesOfDevelopments,
      newResume: false
    };
    _this.questionsUpdated = _this.questionsUpdated.bind(_this);
    _this.moreThanTwoExperiences = _this.moreThanTwoExperiences.bind(_this);
    _this.toggleExperience = _this.toggleExperience.bind(_this);
    _this.initProfileSuggestions = _this.initProfileSuggestions.bind(_this);
    _this.handleUpdateTags = _this.handleUpdateTags.bind(_this);
    _this.handleUpdatePastRoles = _this.handleUpdatePastRoles.bind(_this);
    _this.handleUpdateEducations = _this.handleUpdateEducations.bind(_this);
    _this.handleUpdateBio = _this.handleUpdateBio.bind(_this);
    _this.handleUpdateLocation = _this.handleUpdateLocation.bind(_this);
    _this.nextPage = _this.nextPage.bind(_this);
    _this.claimInfo = _this.claimInfo.bind(_this);
    _this.renderNavigationButtons = _this.renderNavigationButtons.bind(_this);
    _this.handleNewResume = _this.handleNewResume.bind(_this);
    return _this;
  }
  _inherits(Beginning, _Component);
  return _createClass(Beginning, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var bio = nextProps.bio,
        location = nextProps.location,
        education = nextProps.education,
        pastRoles = nextProps.pastRoles,
        functionalAreas = nextProps.functionalAreas,
        therapeuticAreas = nextProps.therapeuticAreas,
        industries = nextProps.industries,
        productTechnologies = nextProps.productTechnologies,
        stagesOfDevelopments = nextProps.stagesOfDevelopments;
      this.setState({
        bio: bio,
        location: location,
        education: education,
        pastRoles: pastRoles,
        functionalAreas: functionalAreas,
        therapeuticAreas: therapeuticAreas,
        industries: industries,
        productTechnologies: productTechnologies,
        stagesOfDevelopments: stagesOfDevelopments
      });
    }
  }, {
    key: "questionsUpdated",
    value: function questionsUpdated() {
      this.setState({
        wasQuestionsUpdated: true
      });
    }
  }, {
    key: "claimInfo",
    value: function claimInfo(position) {
      var _this2 = this;
      var _this$props = this.props,
        claimInfoUrl = _this$props.claimInfoUrl,
        csrfToken = _this$props.csrfToken,
        questionnaire = _this$props.questionnaire,
        updateQuestionnaire = _this$props.updateQuestionnaire,
        userId = _this$props.userId,
        handleMenuUpdate = _this$props.handleMenuUpdate,
        errorsProfileSuggestions = _this$props.errorsProfileSuggestions;
      var _this$state = this.state,
        page = _this$state.page,
        pastRoles = _this$state.pastRoles;
      analyticsTrack('Clicked on Next', {
        location: 'Onboarding Flow',
        step: 'Start Here',
        position: position,
        userId: userId
      });
      var updatedQuestionnaire;
      var data;
      if (page === 0) {
        if (errorsProfileSuggestions.is) {
          return;
        }
        data = processedProfileSuggestions(this.state);
        updatedQuestionnaire = questionnaire;
      }
      if (page === 1) {
        data = this.state.experiences;
        Object.keys(data).forEach(function (key) {
          data[key] = data[key].filter(function (item) {
            return !item.remove;
          });
        });
        updatedQuestionnaire = questionnaire.filter(function (questions) {
          return questions.every(function (q) {
            return !Object.keys(data).includes(q.question_key);
          });
        });
      } else if (page === 2) {
        updatedQuestionnaire = questionnaire.filter(function (questions) {
          return questions.every(function (q) {
            return q.question_key !== 'past_roles';
          });
        });
        data = {
          past_roles: pastRoles.filter(function (item) {
            return !item.remove;
          })
        };
      }
      putRequest(claimInfoUrl, {
        claim_info: data
      }, csrfToken).then(function () {
        updateQuestionnaire(updatedQuestionnaire);
        _this2.nextPage();
        handleMenuUpdate(true);
      });
    }
  }, {
    key: "moreThanTwoExperiences",
    value: function moreThanTwoExperiences() {
      var experiences = this.state.experiences;
      return Object.values(experiences).filter(function (exp) {
        return exp.length > 0;
      }).length >= 2;
    }
  }, {
    key: "toggleExperience",
    value: function toggleExperience(experienceCategory, experience) {
      var experiences = this.state.experiences;
      var index = experiences[experienceCategory].findIndex(function (x) {
        return x.name === experience;
      });
      var _boolean = experiences[experienceCategory][index].remove || false;
      this.setState({
        experiences: update(experiences, _defineProperty({}, experienceCategory, _defineProperty({}, index, {
          $merge: {
            remove: !_boolean
          }
        })))
      });
      analyticsTrack("".concat(_boolean ? 'Add' : 'Delete', " experience"), {
        location: 'Onboarding Flow',
        specific_location: 'Claim Info',
        experience_category: experienceCategory
      });
    }
  }, {
    key: "initProfileSuggestions",
    value: function initProfileSuggestions(profileSuggestions) {
      this.setState(_objectSpread({}, profileSuggestions));
    }
  }, {
    key: "handleNewResume",
    value: function handleNewResume(cleared) {
      this.setState({
        newResume: cleared
      });
    }
  }, {
    key: "handleUpdateTags",
    value: function handleUpdateTags(id, updatedTags) {
      this.setState(_defineProperty({}, id, updatedTags));
    }
  }, {
    key: "handleUpdatePastRoles",
    value: function handleUpdatePastRoles(updatedPastRoles) {
      this.setState({
        pastRoles: updatedPastRoles
      });
    }
  }, {
    key: "handleUpdateEducations",
    value: function handleUpdateEducations(updatedEducation) {
      this.setState({
        education: updatedEducation
      });
    }
  }, {
    key: "handleUpdateBio",
    value: function handleUpdateBio(updatedBio) {
      this.setState({
        bio: updatedBio
      });
    }
  }, {
    key: "handleUpdateLocation",
    value: function handleUpdateLocation(updatedLocation) {
      this.setState({
        location: updatedLocation
      });
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      var _this$props2 = this.props,
        setStateQuestionnaire = _this$props2.setStateQuestionnaire,
        handleNextStep = _this$props2.handleNextStep;
      var _this$state2 = this.state,
        education = _this$state2.education,
        pastRoles = _this$state2.pastRoles;
      setStateQuestionnaire({
        education: education,
        past_roles: pastRoles
      });
      handleNextStep();
    }
  }, {
    key: "renderInfo",
    value: function renderInfo() {
      var _this3 = this;
      var _this$state3 = this.state,
        page = _this$state3.page,
        pastRoles = _this$state3.pastRoles;
      if (page === 1) {
        return /*#__PURE__*/React.createElement("div", {
          className: "experiences"
        }, /*#__PURE__*/React.createElement("h1", {
          className: "mb-24"
        }, "Experience"), this.renderExperiences('Functional Areas', 'functional_areas'), this.renderExperiences('Therapeutic Areas', 'therapeutic_areas'), this.renderExperiences('Product Technologies', 'product_technologies'), this.renderExperiences('Industries', 'industries'), this.renderExperiences('Stages of Development', 'stages_of_development'), this.renderExperiences('Diseases/Indications', 'diseases_/_indications'));
      }
      if (page === 2) {
        return /*#__PURE__*/React.createElement("div", {
          className: "past-roles body-text-2"
        }, /*#__PURE__*/React.createElement("h1", {
          className: "mb-24"
        }, "Past Roles"), pastRoles.map(function (pastRole, index) {
          return /*#__PURE__*/React.createElement(ClaimPastRole, {
            index: index,
            pastRole: pastRole,
            handleUpdatePastRole: _this3.handleUpdatePastRole
          });
        }));
      }
      return null;
    }
  }, {
    key: "renderExperiences",
    value: function renderExperiences(header, experience) {
      var _this4 = this;
      var experiences = this.state.experiences;
      var exps = experiences[experience];
      if (exps && exps.length > 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "experience"
        }, /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 medium-weight experience-name"
        }, header), exps.map(function (exp) {
          return /*#__PURE__*/React.createElement("span", {
            key: exp.name,
            className: "badge small blue-light ".concat(exp.name.replace(/ +/g, '-').toLowerCase(), " ").concat(exp.remove && 'do-not-add')
          }, /*#__PURE__*/React.createElement("span", null, exp.name), /*#__PURE__*/React.createElement("i", {
            className: "remove-tag fa fa-".concat(exp.remove ? 'plus' : 'times', " ms-2"),
            onClick: function onClick() {
              return _this4.toggleExperience(experience, exp.name);
            },
            role: "presentation"
          }));
        }));
      }
      return null;
    }
  }, {
    key: "renderNavigationButtons",
    value: function renderNavigationButtons(position) {
      var _this5 = this;
      var _this$props3 = this.props,
        onboardType = _this$props3.onboardType,
        uploadingResume = _this$props3.uploadingResume;
      var page = this.state.page;
      var isUploadingResume = uploadingResume && page === 0;
      return /*#__PURE__*/React.createElement(Fragment, null, isUploadingResume && position === 'bottom' && /*#__PURE__*/React.createElement("div", {
        className: "resume-upload-info"
      }, "Please wait for resume file to finish uploading."), /*#__PURE__*/React.createElement("div", {
        className: "questionnaire-navigation-buttons ".concat(position)
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn \n            ".concat(isUploadingResume ? 'btn-disabled' : 'btn-primary-darkest', "\n            ").concat(onboardType, "-continue-clora-profile-setting"),
        onClick: function onClick() {
          return _this5.claimInfo(position);
        }
      }, "Next", ' ', /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-right"
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var _this$props4 = this.props,
        questionnaire = _this$props4.questionnaire,
        questionnaireName = _this$props4.questionnaireName,
        questionableId = _this$props4.questionableId,
        questionableType = _this$props4.questionableType,
        csrfToken = _this$props4.csrfToken,
        isOwner = _this$props4.isOwner,
        updateMenu = _this$props4.updateMenu,
        handleMenuUpdate = _this$props4.handleMenuUpdate,
        handleResumeUpload = _this$props4.handleResumeUpload;
      var questionnaireQuestionIds = questionnaire[0].map(function (x) {
        return x.id;
      });
      var _this$state4 = this.state,
        page = _this$state4.page,
        newResume = _this$state4.newResume;
      if (page === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "main-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "questionnaire-nav"
        }, /*#__PURE__*/React.createElement("div", {
          className: "questionnaire-nav-container"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
          className: "category-name"
        }, "Start Here!"), /*#__PURE__*/React.createElement("div", {
          className: "header-subtext"
        }, "This is where you start building your profile.")), this.renderNavigationButtons('top'))), /*#__PURE__*/React.createElement(QuestionsContainer, {
          questionnaireName: questionnaireName,
          questionIds: questionnaireQuestionIds,
          questionableId: questionableId,
          questionableType: questionableType,
          csrfToken: csrfToken,
          owner: isOwner,
          questionsUpdated: this.questionsUpdated,
          updateMenu: updateMenu,
          handleMenuUpdate: handleMenuUpdate,
          handleNewResume: this.handleNewResume,
          handleResumeUpload: handleResumeUpload
        }), newResume && /*#__PURE__*/React.createElement(Tooltip, {
          title: "HURRAY!",
          description: "We filled your profile based on your resume content. Please review and confirm in the next screens."
        }), this.renderNavigationButtons('bottom'));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "onboarding-beginning claim-info"
      }, /*#__PURE__*/React.createElement(Row, {
        className: "header"
      }, /*#__PURE__*/React.createElement(Col, {
        sm: 9,
        className: "text"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "bold mb-12"
      }, "We found some profile suggestions for you!"), /*#__PURE__*/React.createElement("h2", {
        className: "normal-weight"
      }, "\u2726 You can add it now to your profile and edit it at any time.")), /*#__PURE__*/React.createElement(Col, {
        sm: 3,
        className: "img-container"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "chemist-img",
        className: "d-none d-sm-block pull-right",
        src: chemistImg
      }))), /*#__PURE__*/React.createElement("div", {
        className: "clorify-info"
      }, this.renderInfo()), /*#__PURE__*/React.createElement("div", {
        className: "claim-info-actions"
      }, /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("h2", null, "Do you want to add this information to your Clora profile?"), /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("button", {
        className: "g-flex-50 full-width btn btn-secondary bigger-button mr-40 did-not-claim-".concat(page),
        onClick: function onClick() {
          return _this6.nextPage();
        }
      }, "No, I will set my own profile"), /*#__PURE__*/React.createElement("button", {
        className: "g-flex-50 full-width btn btn-primary bigger-button claim-info-".concat(page),
        onClick: function onClick() {
          return _this6.claimInfo();
        }
      }, "Yes, add to my profile")))));
    }
  }]);
}(Component);
Beginning.propTypes = {
  questionnaire: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape([]))).isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionableId: PropTypes.string.isRequired,
  questionableType: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  isOwner: PropTypes.bool.isRequired,
  claimInfoUrl: PropTypes.string.isRequired,
  setStateQuestionnaire: PropTypes.func.isRequired,
  updateQuestionnaire: PropTypes.func.isRequired,
  handleNextStep: PropTypes.func.isRequired,
  onboardType: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  bio: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
  education: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  pastRoles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  functionalAreas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  therapeuticAreas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  industries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  productTechnologies: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  stagesOfDevelopments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateMenu: PropTypes.bool.isRequired,
  uploadingResume: PropTypes.bool.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  handleResumeUpload: PropTypes.func.isRequired,
  errorsProfileSuggestions: PropTypes.shape({}).isRequired
};
var mapStateToProps = function mapStateToProps(state) {
  var _state$profileSuggest = state.profileSuggestions,
    profileSuggestions = _state$profileSuggest.profileSuggestions,
    errorsProfileSuggestions = _state$profileSuggest.errors;
  return _objectSpread(_objectSpread({}, profileSuggestions.merged), {}, {
    errorsProfileSuggestions: errorsProfileSuggestions
  });
};
export default connect(mapStateToProps)(Beginning);